/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { HTTP_METHOD } from "@nf/constants";
import {
  IPauseSubscriptionRequestModel,
  IPauseSubscriptionResponseModel,
  IUnpauseSubscriptionRequestModel,
} from "../models";
import { skymillHttpService } from "../../../../services";


export class PauseSubscriptionService {
  get url(): string {
    return "/v1";
  }

  public pauseSubscription = (
    data: IPauseSubscriptionRequestModel
  ): Promise<IPauseSubscriptionResponseModel> =>
    skymillHttpService.request<IPauseSubscriptionResponseModel>(
      {
        data: {
          duration_count: data.pausePeriod,
          duration_unit: "month",
        },
        method: HTTP_METHOD.PATCH,
        url: `${this.url}/subscriptions/${data.id}/pause`,
      },
    );

  public unpauseSubscription = (
    data: IUnpauseSubscriptionRequestModel
  ): Promise<IPauseSubscriptionResponseModel> =>
    skymillHttpService.request<IPauseSubscriptionResponseModel>(
      {
        method: HTTP_METHOD.PATCH,
        url: `${this.url}/subscriptions/${data.id}/unpause`,
      },
    );
}
